import dayjs from "dayjs";

export const ACTIVITY_LIST_URL = "activity-log?";
export const ACTIVITY_SUBJECT_LIST_URL = "activity-log-subject";
export const ACTIVITY_LOG_HISTORY_URL =
  "activity-log/model-history/:subjectType/:subjectId";

export const ACTIVITY_LIST = "activity_list";
export const ACTIVITY_SUBJECT_LIST = "activity_subject_list";
export const ACTIVITY_LOG_HISTORY = "activity_log_history";

export const FILTER_DEBOUNCE_DELAY = 1000;
export const FILTER_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const FILTER_DEFAULT_VALUES = {
  "filter[subject-type]": ["all"],
  "filter[domain-id]": ["global"],
  "filter[subject-name]": "",
  "filter[action]": ["all"],
  "filter[causer-id]": ["all"],
  "filter[from]": dayjs()
    .subtract(1, "day")
    .startOf("day")
    .format(FILTER_DATE_FORMAT),
  "filter[to]": dayjs().endOf("day").format(FILTER_DATE_FORMAT),
};

export type activityLodDataType = {
  data: [];
  count: number;
  current_page: number;
  per_page: number;
  total: number;
  total_pages: number;
};

export type activitySubjectDataType = {
  [key: string]: {
    id: string;
    alias: string;
  };
};

export type SelectConfigurationProps = {
  value: any;
  dataList: any;
  label: string;
  onChange: (val, name) => void;
  onFocus?: (val) => void;
  onBlur?: (val) => void;
  className: string;
  dropdownClassName: string;
  dropdownMatchSelectWidth: number;
  placeholder?: string;
  name: string;
  titleForValue?: boolean;
  mode?: "multiple" | "tags";
  showSearch?: boolean;
  defaultTitle?: string;
  defaultValue?: string;
};

export const actionTypeList = {
  created: "Creating",
  updated: "Modified",
  deleted: "Removing",
};

export const actionTableConfig = [
  {
    title: "Entity",
    dataIndex: "type",
  },
  {
    title: "Brand ID",
    dataIndex: "brandId",
  },
  {
    title: "Entity Id",
    dataIndex: "entityId",
  },
  {
    title: "Transition",
    width: "33%",
    dataIndex: "transition",
    className: "log-transition-text",
  },
  {
    title: "Action Type",
    dataIndex: "actionType",
  },
  {
    title: "Author",
    dataIndex: "author",
  },
  {
    title: "Date",
    dataIndex: "date",
  },
];

export type activityLogItem = {
  id: string;
  action: string;
  subject: {
    id: string;
    type: string;
    name: string;
  };
  causer: {
    id: string;
    type: string;
    name: string;
  };
  changes: {
    attributes: {
      active: boolean;
      updated_at: string;
    };
    old: {
      active: boolean;
      updated_at: string;
    };
  };
  domain: string;
  created_at: string;
  updated_at: string;
};
